import Axios from "../utils/http-request";
import { getRequestConfiguration } from "../utils/headerHelper";
import { AxiosErrorResponse } from "../interface/api_request";
import {
  AbsentiesmData,
  EmployeeTurnOverRate,
  TurnoverRateProps,
} from "../components/charts/chart";
import { TimesheetApiResponse, TimesheetData } from "../interface/dashboard";

export const apiGetDashboardStats = async () => {
  try {
    const uri = `/stats/dashboard`;
    const cfg = await getRequestConfiguration({
      "Content-Type": "application/x-www-form-urlencoded",
    });
    return await Axios.get(uri, cfg);
  } catch (e: any) {
    const error = e as AxiosErrorResponse;
    const errorMessage =
      error?.response?.data?.message ||
      error?.response?.data?.msg ||
      error?.message ||
      "An error occurred";
    return {
      data: {},
      status: "error",
      msg: errorMessage,
    };
  }
};

export const apiGetTurnoverRateStats = async (
  period: string,
): Promise<EmployeeTurnOverRate> => {
  const cfg = await getRequestConfiguration({
    "Content-Type": "application/json",
  });

  const res = await Axios.get<{ data: EmployeeTurnOverRate }>(
    `/stats/turnover-rate?${period}`,
    cfg,
  );

  // Return only the data we care about:
  return res.data.data;
};

export const apiGetAbsentiesm = async (
  period: string,
): Promise<AbsentiesmData> => {
  const cfg = await getRequestConfiguration({
    "Content-Type": "application/json",
  });

  const res = await Axios.get<{ data: AbsentiesmData }>(
    `/stats/absentiesm/`,
    cfg,
  );

  return res.data.data;
};

export const apiGetTurnoverReasonStats = async (
  period: string,
): Promise<TurnoverRateProps[]> => {
  const cfg = await getRequestConfiguration({
    "Content-Type": "application/json",
  });

  const res = await Axios.get<{ data: TurnoverRateProps[] }>(
    `/stats/turnover-reason/`,
    cfg,
  );

  return res.data.data;
};

export const apiGetMobilityScore = async () => {
  try {
    const uri = `/employments/compute/mobility`;
    const cfg = await getRequestConfiguration({
      "Content-Type": "application/x-www-form-urlencoded",
    });
    return await Axios.get(uri, cfg);
  } catch (e: any) {
    const error = e as AxiosErrorResponse;
    const errorMessage =
      error?.response?.data?.message ||
      error?.response?.data?.msg ||
      error?.message ||
      "An error occurred";
    return {
      data: {},
      status: "error",
      msg: errorMessage,
    };
  }
};

export const apiGetMobilityScoreByEmployeeId = async (values: {
  employeeId: string;
}) => {
  try {
    const uri = `/employments/compute/mobility/${values.employeeId}`;
    const cfg = await getRequestConfiguration({
      "Content-Type": "application/x-www-form-urlencoded",
    });
    return await Axios.get(uri, cfg);
  } catch (e: any) {
    const error = e as AxiosErrorResponse;
    const errorMessage =
      error?.response?.data?.message ||
      error?.response?.data?.msg ||
      error?.message ||
      "An error occurred";
    return {
      data: {},
      status: "error",
      msg: errorMessage,
    };
  }
};

export const apiGetTimesheetStats = async (
  startDate: string,
  endDate: string,
  facilityId: string,
): Promise<TimesheetData[]> => {
  const cfg = await getRequestConfiguration({
    "Content-Type": "application/json",
  });

  // Build query parameters
  const params = new URLSearchParams();
  params.append("startDate", startDate);
  params.append("endDate", endDate);

  const queryString = params.toString();
  const url = `/stats/timesheets/${facilityId}?${queryString}`;

  const res = await Axios.get<TimesheetApiResponse>(url, cfg);

  // Return only the data array
  return res.data.data;
};

export const apiReportSummaryCharge = async () => {
  try {
    const uri = `/wallets/summary-deduction`;

    return await Axios.post(uri);
  } catch (e: any) {
    console.error(e);
    return {
      data: {},
      status: "error",
      msg: e?.response?.data?.message || e?.message,
    };
  }
};
